import { render } from "./CreateShipment.vue?vue&type=template&id=4f553ffe&scoped=true"
import script from "./CreateShipment.vue?vue&type=script&lang=js"
export * from "./CreateShipment.vue?vue&type=script&lang=js"

import "./CreateShipment.vue?vue&type=style&index=0&id=4f553ffe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f553ffe"]])

export default __exports__